<template>
  <div>
    <b-button variant="outline-light" v-on:click="deleteStockAct()" size="sm" style="padding: 0px;">
      <Icon icon="material-symbols:delete-outline" width="20" height="20" v-b-tooltip.hover.bottom="'SİL'"
        color="#EA5455" />
    </b-button>

  </div>
</template>
<script>
import { Icon } from "@iconify/vue2";
export default {
  components: {
    Icon
  },
  methods: {
    deleteStockAct() {
      this.$root.$emit("deleteStockAct", this.params.data);
    }
  }
};
</script>
